import { Grid, Box as MuiBox, Typography } from '@mui/material';

interface RectangleBoxType {
  propertyName: any;
  propertyValue: any;
  statusIcon: any;
}

const RectangleBox = ({
  statusIcon,
  propertyName,
  propertyValue,
}: RectangleBoxType) => (
  <Grid item border={1} borderRadius={1}>
    <Grid container padding={2} height={{ lg: 80 }} textAlign="left">
      <Grid item xs={2} xl={1}>
        <MuiBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          style={{ width: '50px' }}
        >
          {statusIcon}
        </MuiBox>
      </Grid>
      <Grid
        item
        xs={10}
        xl={11}
        display="flex"
        justifyContent={{ xs: 'center', xl: 'space-between' }}
        alignItems={{ xs: 'flex-start', xl: 'center' }}
        gap={0}
        flexDirection={{ xs: 'column', xl: 'row' }}
      >
        <Typography variant="body1" fontWeight="500">{propertyName}</Typography>
        <Typography variant="body1">{propertyValue}</Typography>
      </Grid>
    </Grid>
  </Grid>
);


export default RectangleBox;
